var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-card',{scopedSlots:_vm._u([{key:"header",fn:function(){return [_c('content-header')]},proxy:true}])},[_c('el-row',{attrs:{"type":"flex","justify":"center"}},[_c('system-media')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }